export const scoreManagerABI = [
    {
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'group', internalType: 'address', type: 'address', indexed: true },
            { name: 'score', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'GroupScoreSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'scoreManagerSetter', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'ScoreManagerSetterSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'validator', internalType: 'address', type: 'address', indexed: true },
            { name: 'score', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ValidatorScoreSet',
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'ZERO_SCORE',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'groupScores',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'validatorScores',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    { stateMutability: 'nonpayable', type: 'function', inputs: [], name: 'initialize', outputs: [] },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'group', internalType: 'address', type: 'address' },
            { name: 'score', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setGroupScore',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'validator', internalType: 'address', type: 'address' },
            { name: 'score', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setValidatorScore',
        outputs: [],
    },
    {
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_scoreManagerSetter', internalType: 'address', type: 'address' }],
        name: 'setScoreManagerSetter',
        outputs: [],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'group', internalType: 'address', type: 'address' }],
        name: 'getGroupScore',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'validator', internalType: 'address', type: 'address' }],
        name: 'getValidatorScore',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getScoreManagerSetter',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
];
